<template>
<div class="ui-body">
        <!-- 01.主体容器 - 头部 Start -->
        <div class="ui-container-header">
            <!-- 01.01.主体容器 - 头部 - 标题 Start -->
            <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
            <!-- 01.01.主体容器 - 头部 - 标题 End -->
            <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
            <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
            <!-- 01.02.主体容器 - 头部 - 副标题 End -->
            <!-- 01.03.主体容器 - 头部 - 按钮组 Start -->
            <div class="ui-container-header-group" v-if="$Permissions(['UserOperation'])">
                <el-button-group>
                    <el-button @click="operateAllCreate" v-if="$Permissions(['UserOperationCreate'])"><i class="ion-ios-add-circle"></i>新增</el-button>
                    <el-button @click="operateAllUpload" v-if="$Permissions(['UserOperationUpload'])"><i class="ion-ios-cloud-upload"></i>导入</el-button>
                    <el-dropdown @command="operateAllDownload" v-if="$Permissions(['UserOperationDownload'])">
                        <el-button><i class="ion-ios-cloud-download"></i>导出<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="all" v-if="$Permissions(['UserOperationDownloadAll'])">导出全部</el-dropdown-item>
                            <el-dropdown-item command="part" v-if="$Permissions(['UserOperationDownloadSelected'])">导出所选</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown @command="operateAllState" v-if="$Permissions(['UserOperationState'])">
                        <el-button><i class="ion-ios-switch"></i>审核<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="adopt" v-if="$Permissions(['UserOperationStateOn'])">批量审核</el-dropdown-item>
                            <el-dropdown-item command="failed" v-if="$Permissions(['UserOperationStateOff'])">批量反审</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button @click="operateAllDelete" v-if="$Permissions(['UserOperationDelete'])"><i class="ion-ios-close-circle"></i>删除</el-button>
                    <el-button @click="operateAllRefresh" v-if="$Permissions(['UserOperationRefresh'])"><i class="ion-ios-refresh-circle"></i>刷新</el-button>
                </el-button-group>
            </div>
            <!-- 01.03.主体容器 - 头部 - 按钮组 End -->
        </div>
        <!-- 01.主体容器 - 头部 End -->

        <!-- 02.主体容器 - 内容 Start -->
        <div class="ui-container-content">
            <div class="ui-content">
                <!-- 02.01.主体容器 - 内容 - 搜索 Start -->
                <div class="ui-container-search" v-if="$Permissions(['UserSearch'])">
                    <div class="ui-search-quick">
                        <!-- 02.01.01.快捷搜索 Start -->
                        <div class="ui-search-quick-input" v-if="$Permissions(['UserSearchQuick'])">
                            <el-input placeholder="请输入用户姓名 / 用户名 ..." v-model="quickSearch" class="input-with-select">
                                <el-button type="primary" slot="append" icon="el-icon-search" @click="clickQuickSearch"></el-button>
                            </el-input>
                        </div>
                        <!-- 02.01.01.快捷搜索 End -->
                        <!-- 02.01.02.更多搜索切换 Start -->
                        <div class="ui-search-quick-button" v-if="$Permissions(['UserSearchMore'])">
                            <el-button @click="searchState=!searchState">更多查询<i :class="searchState?'el-icon-arrow-up':'el-icon-arrow-down'"></i></el-button>
                        </div>
                        <!-- 02.01.02.更多搜索切换 End -->
                    </div>
                    <!-- 02.01.04.更多搜索表单 Start -->
                    <el-collapse-transition>
                        <div class="ui-search-more" v-show="searchState" v-if="$Permissions(['UserSearchMore'])">
                            <el-scrollbar>
                                <el-form ref="arraySearch" :model="arraySearch" :label-position="searchPosition">
                                    <el-row :gutter="30">
                                        <el-col :span="8">
                                            <el-form-item label="用户姓名" prop="title">
                                                <el-input v-model="arraySearch.title" placeholder="请输入管理员姓名"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="用户名" prop="user_name">
                                                <el-input v-model="arraySearch.user_name" placeholder="请输入用户名"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="联系电话" prop="phone">
                                                <el-input v-model="arraySearch.phone" placeholder="请输入联系电话"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30">
                                        <el-col :span="8">
                                            <el-form-item label="电子邮箱" prop="mail">
                                                <el-input v-model="arraySearch.mail" placeholder="请输入电子邮箱"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="审核状态" prop="state">
                                                <el-select v-model="arraySearch.state" clearable placeholder="请选择审核状态">
                                                    <el-option label="待审" value="0"></el-option>
                                                    <el-option label="通过" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </el-scrollbar>
                            <div class="ui-search-more-group">
                                <el-button type="primary" icon="ion-ios-search" @click="clickArraySearch">搜索</el-button>
                                <el-button icon="ion-ios-repeat" @click="resetArraySearch">重置</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <!-- 02.01.04.更多搜索表单 End -->
                </div>
                <!-- 02.01.主体容器 - 内容 - 搜索 End -->
                <!-- 02.02.主体容器 - 内容 - 表格 Start -->
                <div class="ui-container-table" v-if="$Permissions(['UserTable'])">
                    <el-table :data="tableData" height="100%" @selection-change="operateSelection" v-loading="tableLoading">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="title" label="用户姓名" width="120"></el-table-column>
                        <el-table-column prop="user_name" label="用户名" width="150"></el-table-column>
                        <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
                        <el-table-column prop="mail" label="电子邮件"></el-table-column>
                        <el-table-column prop="last_time" label="上次登录时间" width="200"></el-table-column>
                        <el-table-column prop="count" label="登录次数" width="100"></el-table-column>
                        <el-table-column prop="state" label="审核状态" width="100" v-if="$Permissions(['UserTableState'])">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.state" :active-value="true" :inactive-value="false" active-text inactive-text @change="operateState($event,scope.row.id)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="230" v-if="$Permissions(['UserTableOperation'])">
                            <template slot-scope="scope">
                                <el-button-group class="ui-table-button-group">
                                    <el-button size="mini" @click="operateResetPass(scope.row.id)" v-if="$Permissions(['UserTableOperationReset'])">重置密码</el-button>
                                    <el-button size="mini" @click="operatePatch(scope.row.id)" v-if="$Permissions(['UserTableOperationPatch'])">编辑</el-button>
                                    <el-button size="mini" @click="operateDelete(scope.row.id)" v-if="$Permissions(['UserTableOperationDelete'])">删除</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 02.02.主体容器 - 内容 - 表格 End -->
            </div>
        </div>
        <!-- 02.主体容器 - 内容 End -->

        <!-- 03.主体容器 - 尾部 Start -->
        <div class="ui-container-footer ">
            <!-- 03.02.主体容器 - 尾部 - 分页 Start -->
            <div class="ui-container-footer-pagination">
                <el-pagination background :current-page="tablePage" :page-sizes="pageSizes" :page-size="pageSize" :total="tableTotal" layout="sizes, prev, pager, next, jumper, total" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
            </div>
            <!-- 03.02.主体容器 - 尾部 - 分页 End -->
        </div>
        <!-- 03.主体容器 - 尾部 End -->

        <!-- 04.批量导入 Start -->
        <el-dialog class="ui-import" title="批量导入数据" :visible.sync="uploadDialog" width="60%" v-if="$Permissions(['UserOperationUpload'])">
            <Upload v-if="uploadDialog" a-title="系统用户信息表模板" a-template="/static/template/用户模板.xlsx" a-api="/api/upload/user/"></Upload>
        </el-dialog>
        <!-- 04.批量导入 End -->
    </div>
</template>

<script>
    import Upload from "../common/upload"

    export default {
        name: "data_user",
        components: {Upload},
        data() {
            return {
                // 01.显示模式 ------------------------------------------------
                // 01.01.TreeID
                treeID: "",
                // 01.数据搜索 ------------------------------------------------
                // 01.01.快捷搜索
                quickSearch:'',
                // 01.02.更多搜索
                arraySearch: {
                    title: '',
                    user_name: '',
                    phone: '',
                    mail: '',
                    content: ''
                },
                // 01.03.Search 显示状态
                searchState: false,
                // 01.04.Search 配置 - 标题位置
                searchPosition: 'top',
                // 02.数据数组 ------------------------------------------------
                // 02.01.数据数组 - 数据集
                tableData: [],
                // 02.02.数据数组 - 加载组件
                tableLoading: true,
                // 02.03.所选数据
                multipleTable: [],
                // 03.分页栏目 ------------------------------------------------
                // 03.01.分页栏目 - 当前页
                tablePage: 1,
                // 03.02.分页栏目 - 数据总量
                tableTotal: 400,
                // 03.03.分页栏目 - 每页数量条数
                pageSizes: [20, 50, 100, 200],
                // 03.04.分页栏目 - 分页条数
                pageSize: 20,
                // 04.数据上传/更新 ------------------------------------------------
                // 04.01.上传窗口状态
                uploadDialog: false,
            }
        },
        // 方法集合
        methods: {
            // 01.批量操作 ------------------------------------------------
            // 01.01.全选数据
            operateSelection(val) {
                this.multipleTable = []
                this.multipleSelection = val
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    this.multipleTable.push(this.multipleSelection[i]['id'])
                }
            },
            // 01.02.新增
            operateAllCreate() {
                this.$router.replace('/manage/user/add-user')
            },
            // 01.03.批量导入
            operateAllUpload() {
                this.uploadDialog = true
                this.uploadSteps = 0
            },
            // 01.04.批量导出
            operateAllDownload(command) {
                // 01.04.01.导出全部
                if (command === 'all') {
                    this.$confirm('是否批量导出全部数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get("/api/download/user/").then((response) => {
                            this.$message.success(response.message)
                            window.open(this.$api_url + response.path)
                        })
                    }).catch(() => {

                    })
                }
                // 01.04.02.导出所选
                if (command === 'part') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要导出的数据')
                    } else {
                        this.$confirm('是否批量导出所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get("/api/download/user-active/", {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response.message)
                                window.open(this.$api_url + response.path)
                            })
                        }).catch(() => {

                        })
                    }
                }
            },
            // 01.05.批量审核
            operateAllState(command) {
                // 01.05.01.批量审核
                if (command === 'adopt') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要审核的数据')
                    } else {
                        this.$confirm('是否批量审核所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get('/api/state/user-on/', {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response)
                                this.operateAllRefresh()
                            })
                        }).catch(() => {

                        })
                    }
                }
                // 01.05.02.批量反审
                if (command === 'failed') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要反审的数据')
                    } else {
                        this.$confirm('是否批量反审所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get('/api/state/user-off/', {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response)
                                this.operateAllRefresh()
                            })
                        }).catch(() => {

                        })
                    }
                }
            },
            // 01.06.批量删除
            operateAllDelete() {
                if (this.multipleTable.length === 0) {
                    this.$message.warning('请选择需要删除的数据')
                } else {
                    this.$confirm('是否批量删除所选数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get('/api/delete/user-active/', {'id': this.multipleTable}).then((response) => {
                            this.$message.success(response)
                            this.operateAllRefresh()
                        })
                    }).catch(() => {

                    })
                }
            },
            // 01.07.刷新
            operateAllRefresh() {
                this.getTableJson()
            },
            // 02.表格操作 ------------------------------------------------
            // 02.01.编辑
            operatePatch(value) {
                this.$router.replace('/manage/user/patch-user/' + value)
            },
            // 02.02.删除
            operateDelete(value) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.get('/api/delete/user/', {'id': value}).then((response) => {
                        this.$message.success(response)
                        this.operateAllRefresh()
                    })
                })
            },
            // 02.03.审核
            operateState(event, value) {
                this.$api.get('/api/state/user/', {'id': value, 'state': event}).then((response) => {
                    this.$message.success(response)
                    this.getTableJson()
                })
            },
            // 02.04.重置密码
            operateResetPass(value) {
                this.$confirm('是否重置该管理密码？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.post("/api/patch/user-reset-password/", {'id': value}).then((response) => {
                        if (response.code === 200) {
                            this.$alert(response.message, '重置密码反馈', {
                                confirmButtonText: '确定'
                            })
                        } else {
                            this.$message.error(response.message)
                        }
                    })
                })
            },
            // 03.获取数据 ------------------------------------------------
            // 03.01.获取Json数据 ( tablePage 当前页  pageSize 分页条数  quickSearch 快捷搜索  arraySearch 更多搜索 )
            getTableJson() {
                this.arraySearch.quick_search = this.quickSearch
                this.arraySearch.table_page = this.tablePage
                this.arraySearch.page_size = this.pageSize
                this.$api.get('/api/get/user-array/', this.arraySearch).then((response) => {
                    this.tableData = response.data
                    this.pageSize = response.page_size
                    this.tableTotal = response.table_total
                    this.tablePage = response.table_page
                    this.tableLoading = false
                })
            },
            // 03.02.分页栏目 - 分页数
            changeSize(val) {
                // 01.赋值分页数
                this.pageSize = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 03.03.分页栏目 - 跳转页
            changeCurrent(val) {
                // 01.赋值跳转页
                this.tablePage = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 04.搜索/查询操作 ------------------------------------------------
            // 04.01.快捷搜索/查询
            clickQuickSearch() {
                // 01.获取Json数据
                this.getTableJson()
            },
            // 04.02.搜索/查询 - 查询提交
            clickArraySearch() {
                // 01.获取Json数据
                this.getTableJson()
                this.searchState = false
            },
            // 04.03.搜索/查询 - 重置Form表单
            resetArraySearch() {
                this.$refs['arraySearch'].resetFields()
                this.getTableJson()
                this.searchState = false
            },
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.获取Json数据
            this.getTableJson()
        },
    }
</script>
